import { withStyles } from '@material-ui/core';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import { useNavigate } from 'react-router-dom';
import styles from '../../layout/layoutHeader/components/styles';
import StyledToolTip from '../common/StyledToolTip';
import { compose } from 'recompose';
import { withAppConfig } from '../../appConfigContext';

const WatchTutorial = ({ componentId, showLabel, configJSON, classes }) => {
  const navigate = useNavigate();
  const showTutorial = () => {
    navigate(`?componentId=${componentId}`);
  };
  const isAppTutorialEnabled = configJSON.appTutorialEnabledComponents?.includes(componentId);
  
  if(!isAppTutorialEnabled){
    return null;
  }

  return (
    <div
      className={`${showLabel ? classes.iconWithLabel : classes.headerIconStyles} ${
        classes.iconLayout
      } glHeaderIcons 
      ${classes.enabledIcon}`}
      onClick={showTutorial}>
      <StyledToolTip title={showLabel ? '' : 'Watch Tutorial'}>
        <PlayCircleOutlineIcon />
      </StyledToolTip>
      {showLabel && <span className={classes.iconLabel}>Watch Tutorial</span>}
    </div>
  );
};

export default compose(withAppConfig, withStyles(styles))(WatchTutorial);
